import AppDropdown from "@/components/AppDropdown.vue";
import AppDropdownPartitionTitle from "@/components/AppDropdownPartitionTitle.vue";
import AppDropdownItem from '@/components/AppDropdownItem.vue';
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import SearchElement from '@/components/new-filters/SearchElement.vue';
import { getDescriptionBasedOnKpiKey } from "@/utils/transformers";
import StrokedViewIcon from "@/components/icons/StrokedViewIcon.vue";
import StrokedHideIcon from "@/components/icons/StrokedHideIcon.vue";
export default {
  name: "EvolutionChartController",
  emits: ['update:modelValue'],
  props: {
    title: {
      type: String
    },
    color: {
      type: String
    },
    modelValue: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    compare: {
      type: Object
    },
    compareOptions: {
      type: Array,
      default: () => []
    },
    showEvolution: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AppDropdown,
    AppDropdownPartitionTitle,
    AppDropdownItem,
    WrapWithPopover,
    SearchElement,
    StrokedViewIcon,
    StrokedHideIcon
  },
  data() {
    return {
      searchQuery: ""
    };
  },
  computed: {
    metric: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      }
    },
    compareSelected: {
      get() {
        return this.compare;
      },
      set(v) {
        console.log("compare:update", v);
        this.$emit("update:compare", v);
      }
    },
    filteredOptions() {
      if (!this.searchQuery) {
        return this.options;
      }
      const query = this.searchQuery.toLowerCase();
      return this.options.map(([category, items]) => {
        const filteredItems = items.filter(item => item?.label?.toLowerCase().includes(query) || item?.fullLabel?.toLowerCase().includes(query) || item?.key?.toLowerCase().includes(query));
        return [category, filteredItems];
      }).filter(([_, filteredItems]) => filteredItems.length > 0);
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    handleSearch({
      value
    }) {
      this.searchQuery = value[0] || "";
    },
    getKpiDescription(key = String()) {
      if (key.includes("_evol")) return null;
      return this.getDescriptionBasedOnKpiKey(key);
    }
  }
};